import { render, staticRenderFns } from "./OrderListItemHead.vue?vue&type=template&id=474e3551&scoped=true"
import script from "./OrderListItemHead.vue?vue&type=script&lang=js"
export * from "./OrderListItemHead.vue?vue&type=script&lang=js"
import style0 from "./OrderListItemHead.vue?vue&type=style&index=0&id=474e3551&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474e3551",
  null
  
)

export default component.exports